import { PagaduriasCondicionesService } from './../../_services/pagadurias-condiciones.service';
import { PagaduriaCondicion } from './../../_models/pagaduria-condicion';
import { Funcionalidad } from './../../_models/funcionalidad';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Localizaciones } from '../../_models/localizaciones';
import { GestorCentralizado, GestorCentralizadoSolicitud, GestorCentralizadoUnidad } from '../../_models/gestor-centralizado';
import { NavService } from '../../_services/_nav.service';
import { LocalizacionesComponent } from '../../shared/localizaciones/localizaciones.component';
import {
  CodigosEstadosFuncionalidades,
  FuncionalidadAuditoria,
  Integraciones,
  ListaAccionesAuditorias,
  TiposDirecciones, TipoTelefono,
  Vinculaciones
} from '../../_enums/enum';
import {firstValueFrom, forkJoin, Observable, of} from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { Tercero } from '../../_models/tercero';
import { TerceroTelefono } from '../../_models/tercero-telefono';
import { ListaItem } from '../../_models/lista-item';
import { SolicitudUnidadCredito } from '../../_models/solicitud-unidad-credito';
import { Location } from '@angular/common';
import { TerceroService } from '../../_services/tercero.service';
import { Canal } from '../../_models/canal';
import swal from 'sweetalert2';
import { DivisionPoliticaService } from '../../_services/division-politica.service';
import { CentralRiesgoIntegracionService } from '../../_services/central-riesgo-integracion.service';
import { AuditoriaControlService } from '../../_services/auditoria-control.service';
import { TerceroTelefonoService } from '../../_services/tercero-telefono.service';
import { ConstanteService } from '../../_services/constante.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { UsuarioRol } from '../../_models/usuario-rol';
import { Rol } from '../../_models/rol';
import { PermisosSeccionesControlesService } from '../../_services/permisos-secciones-controles.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GestorPreaprobado } from '../../_models/gestor-preaprobado';
import { Pagaduria } from '../../_models/pagaduria';
import { TerceroLocalizacionesService } from '../../_services/tercero-localizaciones.service';
import { TerceroLocalizacion } from '../../_models/tercero-localizacion';
import { PagaduriaService } from '../../_services/pagaduria.service';
import { sleep, Utilidades } from '../../utils/utilidades';
import { DivisionPolitica } from '../../_models/division-politica';
import { LocalizacionesService } from '../../_services/localizaciones.service';
import { TerceroTipoTerceroService } from '../../_services/tercero-tipo-tercero.service';
import {BusquedaFiltros} from '../../_models/busqueda-filtros';
import {catchError, map} from 'rxjs/operators';
import {DominiosCorreosService} from '../../_services/dominios-correos.service';


@Component( {
  selector: 'app-pagaduria-editar',
  templateUrl: './pagaduria-editar.component.html',
  styleUrls: [ './pagaduria-editar.component.scss' ],

} )
export class PagaduriaComponent implements OnInit, OnDestroy {
  @Input() centralizadoSolicitud: GestorCentralizadoSolicitud;
  @Input() centralizadoUnidad: GestorCentralizadoUnidad;
  @Input() gestorCentralizado: GestorCentralizado;


  tiposTelefonosEnum = TipoTelefono;
  constante: any;
  tercero: Tercero;
  roles: Rol;
  tipepa: any;
  tabSeleccionado = 'EDITAR';
  terLocalizaciones: TerceroLocalizacion;
  terlocali: any;
  exisTercero = false;
  indica = false;
  validateOk = false;
  guardando = false;
  cargandoDireccion = false;
  submitted = false;
  habilitado = false;
  tipoDireccion = TiposDirecciones;
  divisionPolitica: DivisionPolitica;
  carInformacionInicial = true;
  formulario: FormGroup;
  TerceroTelefonoPrincipal: TerceroTelefono;
  estadosFuncionalidades: CodigosEstadosFuncionalidades;
  locEmpleado: any;
  idTipoSociedad: number;
  idEstado: number;
  cargandoValidacion = false;
  funcionAuditoria = FuncionalidadAuditoria;
  lisAccionesAuditorias = ListaAccionesAuditorias;
  tipoTercero: any;
  pagaduria: Pagaduria;
  localizacion: Localizaciones;
  carMunicipio = false;
  locali: Localizaciones;
  departamento: DivisionPolitica;
  addinglocation = true;
  lisTerceroTelefono: TerceroTelefono[];
  banderaValidarTercero = false;

  canalDatosTercero: Canal;
  verificar = true;
  nitTemp: number;
  mosModalDenegacion = false;
  campoObservacion: any;
  campoObservacionSubmitted = false;
  utilidades = new Utilidades();
  codTipoDato: string = null;

  // Listas para combo-box
  lisTiposSociedades: SelectItem[] = [];
  lisTiposSociedadesAplicables: ListaItem[] = [];
  lisTiposSectores: SelectItem[] = [];
  lisTiposSectoresAplicables: ListaItem[] = [];
  lisTiposTelefonos: SelectItem[] = [];
  lisTiposTelefonosAplicables: ListaItem[] = [];
  lisEstadosFuncionalidades: SelectItem[] = [];
  lisTiposEstadosAplicables: ListaItem[] = [];
  lisTipoDocumento: SelectItem[] = [];
  lisTiposDocumentosAplicables: ListaItem[] = [];
  lisPersonas: SelectItem[] = [];
  lisPersonasAplicables: ListaItem[] = [];
  lisTerceros: SelectItem[] = [];
  lisTercerosAplicables: ListaItem[] = [];
  listasEmpresasAleatoriasAplicables: ListaItem[] = [];
  listasEmpresasAleatorias: SelectItem[] = [];
  contanteRDUCON: any;
  contanteRDUAPR: any;
  usuarioLogeado: any;
  funcionalidad: Funcionalidad = new Funcionalidad();
  verAprobacionCondicion = false;
  pagaduriaCondicion: PagaduriaCondicion;
  activeIndex: number = 0;

  constructor( private router: Router,
               private route: ActivatedRoute,
               private dialogService: DialogService,
               private fb: FormBuilder,
               private autenticacionService: AutenticacionService,
               private location: Location,
               private terLocalizacionesService: TerceroLocalizacionesService,
               private navService: NavService,
               private lisServicio: ListaService,
               private terServicio: TerceroService,
               private confirmationService: ConfirmationService,
               private localizacionService: LocalizacionesService,
               private conConstanteServicio: ConstanteService,
               private terTelefonoService: TerceroTelefonoService,
               private divPoliticaServicio: DivisionPoliticaService,
               private tertipostercerosService: TerceroTipoTerceroService,
               private pagaduriaService: PagaduriaService,
               private permisosSeccionesControlesService: PermisosSeccionesControlesService,
               private auditoriaControlService: AuditoriaControlService,
               private divisionPoliticaServicio: DivisionPoliticaService,
               private centalesRiesgoIntegracionesServicio: CentralRiesgoIntegracionService,
               private pagaduriasCondicionesService: PagaduriasCondicionesService,
               private dominios : DominiosCorreosService,
  ) {
  }


  async ngOnInit() {
    // SETEAR VALOR POR MEDIO DE UN ROUTER
    this.route.params.subscribe( async( params: Params ) => {
      if ( params[ 'id' ] ) {
        this.pagaduria = await this.pagaduriaService.getById( params[ 'id' ] ).toPromise();
        const [ tercero, tercerLoca, localizacion, municipio ] = await forkJoin( this.terServicio.get( this.pagaduria.idTercero ),
          this.terLocalizacionesService.get( this.pagaduria.idTerceroLocalizacion ),
          this.localizacionService.getById(this.pagaduria.idLocalizacion, true),
          this.divisionPoliticaServicio.viewDivisionPolitica(this.pagaduria.idDivisionPoliticaPadre)).toPromise();
        this.tercero = tercero;
        if (municipio && municipio.idDivisionPoliticaPadre) {
          this.departamento = await this.divisionPoliticaServicio.viewDivisionPolitica(municipio.idDivisionPoliticaPadre).toPromise();
        }
        this.terLocalizaciones = tercerLoca;
        this.localizacion = localizacion;
        this.divisionPolitica = municipio;
      }
      this.cargarFormulario();
      this.cargarInicial();
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      codigo: [ this.pagaduria ? this.pagaduria.codigo : null ],
      nit: [ this.tercero ? this.tercero.numeroDocumento : null, [ Validators.required, Validators.maxLength(13) ], ],
      digitoVerificacion: [ this.pagaduria ? this.pagaduria.digitoVerificacion : null, [ Validators.required ] ],
      razonSocial: [ this.tercero ? this.tercero.razonSocial : null, [ Validators.required ], ],
      tipoSociedad: [ this.tercero ? this.tercero.idTipoSociedad : null, [ Validators.required ], ],
      idSector: [ this.pagaduria ? this.pagaduria.idSector : null, [ Validators.required ], ],
      ciudad: [this.divisionPolitica ? this.divisionPolitica.descripcionDivisonPolitica : null, [ Validators.required ], ],
      departamento: [this.departamento ? this.departamento.descripcionDivisonPolitica : null, [ Validators.required ], ],
      idTipoTelefono1: [ this.pagaduria ? this.pagaduria.idTipoTelefono1 : null, [ Validators.required ], ],
      telefonoContacto1: [ this.pagaduria ? this.pagaduria.telefonoContacto1 : null, [ Validators.required ], ],
      direccionEmpresa: [ this.pagaduria ? this.pagaduria.direccion : null, [ Validators.required ] ],
      correoElectronico: [ this.pagaduria ? this.pagaduria.correoElectronico : null, [ Validators.maxLength( 128 ), Validators.pattern( '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$' ), Validators.required ] ],
      cargoContacto: [ this.pagaduria ? this.pagaduria.cargoContacto : null, [ Validators.required ], ],
      nombreContacto: [ this.pagaduria ? this.pagaduria.nombreContacto : null, [ Validators.required ], ],
      idTipoTelefono2: [ this.pagaduria ? this.pagaduria.idTipoTelefono2 : null, [] ],
      telefonoContacto2: [ this.pagaduria ? this.pagaduria.telefonoContacto2 : null, [] ],
      indicadorFondoPension: [ this.pagaduria ? this.pagaduria.indicadorFondoPension : false ],
      idEstadoFuncionalidad: [ this.pagaduria ? this.pagaduria.idEstadoFuncionalidad : null, [ Validators.required ], ],
      idEntidad: [ this.pagaduria ? this.pagaduria.idEntidad : null, [ Validators.required ], ],
      codigoShivam: [ this.pagaduria ? this.pagaduria.codigoShivam : null, [ Validators.required ] ],
    } );
  }

  cargarInicial() {
    forkJoin(
      this.lisServicio.getMasterDetails( 'ListasTiposTelefonos' ),
      this.lisServicio.getMasterDetails( 'ListasTiposSociedades' ),
      this.lisServicio.getMasterDetails( 'ListasTiposDocumentos' ),
      this.lisServicio.getMasterDetails( 'ListasSectores' ),
      this.lisServicio.getMasterDetails( 'ListasEstadosFuncionalidades' ),
      this.lisServicio.getMasterDetails( 'ListasEmpresasAleatorias' ),
      this.lisServicio.getMasterAllDetails('ListasTiposPersonas'),
      this.conConstanteServicio.getByCode( 'RDUCON' ),
      this.conConstanteServicio.getByCode( 'RDUAPR' )
    ).subscribe( ( [ lisTiposTelefonos,
                     lisTiposSociedades,
                     lisTipoDocumento,
                     lisTiposSectores,
                     lisEstadosFuncionalidades,
                     listasEmpresasAleatorias,
                     lisTiposPersonas, rdcon, ruapr] ) => {
      this.contanteRDUCON = rdcon;
      this.contanteRDUAPR = ruapr;
      this.funcionalidad = this.autenticacionService.obtenerFuncionalidades().find( x => x.ruta === 'apl/pagaduria' );
      this.usuarioLogeado = this.autenticacionService.obtenerRolesUsuarios();
      this.validarRolesConfigurados();
      this.lisTipoDocumento = [];
      this.lisTiposDocumentosAplicables = lisTipoDocumento;
      lisTipoDocumento.forEach( ( s: ListaItem ) => {
        this.lisTipoDocumento.push( { label: s.codigo, value: s.idLista } );
      } );
      this.lisTiposSociedades = [];
      this.lisTiposSociedadesAplicables = lisTiposSociedades;
      lisTiposSociedades.forEach( ( s: ListaItem ) => {
        this.lisTiposSociedades.push( { label: s.nombre, value: s.idLista } );
      } );
      this.lisTiposSectores = [];
      this.lisTiposSectoresAplicables = lisTiposSectores;
      lisTiposSectores.forEach( ( s: ListaItem ) => {
        this.lisTiposSectores.push( { label: s.nombre, value: s.idLista } );
      } );
      this.lisTiposTelefonos = [];
      this.lisTiposTelefonosAplicables = lisTiposTelefonos;
      lisTiposTelefonos.forEach( ( s: ListaItem ) => {
        this.lisTiposTelefonos.push( { label: s.nombre, value: s.idLista } );
      } );
      this.lisPersonas = [];
      this.lisPersonasAplicables = lisTiposPersonas;
      lisTiposPersonas.forEach( ( s: ListaItem ) => {
        this.lisPersonas.push( { label: s.nombre, value: s.idLista } );
      } );
      this.lisEstadosFuncionalidades = [];
      this.lisTiposEstadosAplicables = lisEstadosFuncionalidades;
      lisEstadosFuncionalidades.forEach( s => {
        if ( CodigosEstadosFuncionalidades.PENDIENTE !== s.codigo &&
          CodigosEstadosFuncionalidades.APROBADO !== s.codigo &&
          CodigosEstadosFuncionalidades.DENEGADO !== s.codigo ) {
          this.lisEstadosFuncionalidades.push( { label: s.nombre, value: s.idLista } );
        }
      } );
      this.listasEmpresasAleatoriasAplicables = listasEmpresasAleatorias;
      listasEmpresasAleatorias.forEach( ( s: ListaItem ) => {
        this.listasEmpresasAleatorias.push( { label: s.nombre, value: s.idLista } );
      })
      this.carInformacionInicial = false;
    } );
  }

  verificarTipoTelefon1(reiniciar: boolean = true) {
    const tipo = this.lisTiposTelefonosAplicables.find( x => x.idLista === this.f.idTipoTelefono1.value );
    this.codTipoDato = tipo ? tipo.codigo : null;
    this.f.telefonoContacto1.setValidators( [ Validators.required, Validators.minLength( this.codTipoDato === this.tiposTelefonosEnum.FIJO ? 7 : 10 ) ] );
    this.f.telefonoContacto1.updateValueAndValidity();
    if (reiniciar) {
      this.f.telefonoContacto1.setValue( null );
    }
  }

  verificarTipoTelefono2(reiniciar: boolean = true) {
    const tipo = this.lisTiposTelefonosAplicables.find( x => x.idLista === this.f.idTipoTelefono2.value );
    this.codTipoDato = tipo ? tipo.codigo : null;
    this.f.telefonoContacto2.setValidators( [ Validators.minLength( this.codTipoDato === this.tiposTelefonosEnum.FIJO ? 8 : 10 ) ] );
    this.f.telefonoContacto2.updateValueAndValidity();
    if (reiniciar) {
      this.f.telefonoContacto2.setValue( null );
    }
  }

  async lanzarActualizarDatosPersonas( tercero: Tercero, terceroNuevo: boolean ) {
    tercero.codigoTipoDocumento = this.lisTiposDocumentosAplicables.find( ti => ti.idLista === tercero.idTipoDocumento ).codigo;
    if ( terceroNuevo && tercero.codigoTipoDocumento ) {
      const respuesta = await this.terServicio.actualizarDatosPersona(
        tercero.codigoTipoDocumento, Number( tercero.numeroDocumento ) ).toPromise();
      return;
    }
    if ( this.canalDatosTercero && !this.canalDatosTercero.indicadorActDatosTercero && tercero.codigoTipoDocumento ) {
      const respuesta = await this.terServicio.actualizarDatosPersona(
        tercero.codigoTipoDocumento, Number( tercero.numeroDocumento ) ).toPromise();
    } else if ( this.canalDatosTercero && this.canalDatosTercero.indicadorActDatosTercero && this.verificar && tercero.codigoTipoDocumento ) {
      const respuesta = await this.terServicio.actualizarDatosPersona(
        tercero.codigoTipoDocumento, Number( tercero.numeroDocumento ) ).toPromise();
    }
  }

  async lanzarIntegracionConShivam( tercero: Tercero ) {
    tercero.codigoTipoDocumento = this.lisTiposDocumentosAplicables.find( ti => ti.idLista === tercero.idTipoDocumento ).codigo;
    const respuesta = await this.terServicio.actualizarDatosTelefono(
      tercero.codigoTipoDocumento, Number( tercero.numeroDocumento ) ).toPromise();
    if ( !respuesta || ( respuesta.code !== '00' && respuesta.code !== '01' ) ) {
      const msgErrorSync = {
        severity: 'error',
        summary: 'Error',
        detail: ( respuesta && respuesta.result ) ? respuesta.result :
          this.navService.buscarMensaje( 'FLUJOVENTAREDATOSBASICOS.MSG_NOFUEPOSIBLEACTDATOSTERCERO' )
      };
      this.navService.setMesage( 4, msgErrorSync );
    }
  }

  capturarAccion( tercero ) {
    const funcionalidad = this.funcionAuditoria.PAGADURIA;
    const accion = this.lisAccionesAuditorias.BUSCAR;
    this.auditoriaControlService.guardarAuditoriaControl( funcionalidad, accion, tercero.idTercero );
  }

  async validarTelefonos( idTercero: string ) {
    const telefonos = await this.terTelefonoService.listadoPorTercero( idTercero ).toPromise();
    this.lisTerceroTelefono = telefonos;
  }

  validarDatos() {
    if ( this.tercero && this.TerceroTelefonoPrincipal ) {
      this.f.idTipoTelefono1.setValidators( null );
      this.f.idTipoTelefono1.updateValueAndValidity();
      this.f.telefonoContacto1.setValidators( null );
      this.f.telefonoContacto1.updateValueAndValidity();
    } else {
      this.f.idTipoTelefono1.setValidators( [ Validators.required ] );
      this.f.idTipoTelefono1.updateValueAndValidity();
      this.f.telefonoContacto1.setValidators( [ Validators.required ] );
      this.f.telefonoContacto1.updateValueAndValidity();
    }
  }

  async setearValidaresValoresTercero( tercero: any ) {
    this.exisTercero = true;
    this.tercero = tercero;

    this.f.razonSocial.setValue( tercero.razonSocial );
    this.f.tipoSociedad.setValue( tercero.idTipoSociedad );


  }

  reiniciarForm() {
    this.tercero = null;
      this.f.tipoSociedad.setValue(null);
      this.f.razonSocial.setValue(null);
      this.f.indicadorFondoPension.setValue(false);

  }

  inhInput() {
    this.banderaValidarTercero = true;
  }


  async validarTercero() {
    this.banderaValidarTercero = true;
    this.guardando = true;
    const existeEnPagaduria = await firstValueFrom(this.buscarPorFiltros());
    if (existeEnPagaduria) {
      this.f.nit.setValue(null);
      this.mensaje('warn', 'LBL_ATENCION', 'Ya existe una pagaduría con el mismo NIT');
      this.banderaValidarTercero = false;
      this.guardando = false;
      return;
    }
    const tipodocumento = this.lisTiposDocumentosAplicables.find( l => l.codigo === 'NIT' );
    if ( this.f.nit.value && tipodocumento.idLista ) {
      this.guardando = true;
      this.terServicio.validateDocument( this.f.nit.value, tipodocumento.idLista ).subscribe( async tercero => {
        if ( tercero ) {
          this.tercero = tercero;
          this.capturarAccion( tercero );
          this.validarTelefonos( tercero.idTercero );
          this.lanzarIntegracionConShivam( tercero );
          this.lanzarActualizarDatosPersonas( tercero, false );
          await this.setearValidaresValoresTercero( tercero );
          this.cargandoValidacion = true;
          setTimeout( () => {
            this.cargandoValidacion = false;
            this.banderaValidarTercero = false;
          }, 500 );
          this.guardando = false;
        } else {
            if ( this.exisTercero ) {
              this.reiniciarForm();
              this.banderaValidarTercero = false;
              this.guardando = false;
            }
            this.validarDatos();
            this.exisTercero = false;
            this.habilitado = false;
            this.guardando = false;
            this.banderaValidarTercero = false;
          }
      } );
      await this.digitoVerificacion();
    } else {
      this.guardando = false;
    }
  }

  get f() {
    return this.formulario.controls;
  }

  async digitoVerificacion() {
    if ( this.f.nit.value ) {
      const dv = await this.terServicio.verificationDigit( this.f.nit.value ).toPromise();
      this.f.digitoVerificacion.setValue( dv );
    }
  }

  async agregarDirrecion( codigo: string, tipo: Localizaciones ) {
    const locEmpleado = this.formulario.value;
    const locali = {} as Localizaciones;
    if ( codigo === this.tipoDireccion.EMPRESA ) {
      locali.idLocalizacion = locEmpleado.idLocalizacion;
    }
    const modal = this.dialogService.open( LocalizacionesComponent, {
      width: '60%',
      style: {'max-height': '90%'},
      closeOnEscape: false,
      closable: false,
      data: {
        localizacion: Object.assign( {}, this.localizacion ? this.localizacion : tipo ),
        dialogo: true,
        parentTitle: 'Ubicación',
        tipoDirrecion: [ TiposDirecciones.EMPRESA ],
        idSolicitudUnidadCredito: this.centralizadoUnidad?.solUnidadCredito?.idSolicitudUnidadCredito,
      },
    } );
    modal.onClose.subscribe( async( data: any ) => {
      this.cargandoDireccion = false;
      if ( data ) {
        this.locali = data;
        this.localizacion = data;
      } else {
        return;
      }
      this.f.direccionEmpresa.setValue( data ? data.direccion : null );
      this.divPoliticaServicio.obtenerPadre( data.idDivisionPolitica ).subscribe( div => {
        this.f.ciudad.setValue( div.descripcionDivisonPolitica );
        if ( div && div.idDivisionPolitica ) {
          this.divisionPoliticaServicio.viewDivisionPolitica( div.idDivisionPoliticaPadre ).subscribe( dep => {
            this.f.departamento.setValue( dep.descripcionDivisonPolitica );
          } );
        }
      } );
    } );

  }


  mensaje( severity: string, summary: string, detail: string ) {
    this.navService.setMesage( 0,
      {
        severity: severity,
        summary: this.navService.buscarMensaje( summary ),
        detail: this.navService.buscarMensaje( detail )
      } );
  }

  async onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid ) {
      return;
    }
    this.guardando = true;
    const tipodocumento = this.lisTiposDocumentosAplicables.find( l => l.codigo === 'NIT' );
    const naturaleza = this.lisPersonasAplicables.find(x => x.codigo === 'JUR');
    const data = this.formulario.getRawValue();
    data.idTipoDocumento = tipodocumento.idLista;
    this.setearTelefonos(data);
    const registro = this.tercero ? this.tercero : {} as Tercero;
    registro.numeroDocumento = data.nit;
    registro.idTipoPersona = naturaleza.idLista;
    registro.idTipoSociedad = data.tipoSociedad;
    registro.idTipoDocumento = tipodocumento.idLista;
    registro.razonSocial = data.razonSocial;
    registro.indicadorHabilitado = true;


    const terlocalizacion = this.terLocalizaciones ? this.terLocalizaciones : {} as TerceroLocalizacion;
    terlocalizacion.indicadorHabilitado = true;

    const pagaduria = this.pagaduria ? this.pagaduria : {} as Pagaduria;
    const telefono = this.utilidades.quitarMascaraTelefono( data.telefonoContacto1 );
    const telefono2 = this.utilidades.quitarMascaraTelefono( data.telefonoContacto2 );
    pagaduria.nombreContacto = data.nombreContacto;
    pagaduria.cargoContacto = data.cargoContacto;
    pagaduria.idSector = data.idSector;
    pagaduria.indicadorFondoPension = data.indicadorFondoPension;
    pagaduria.correoElectronico = data.correoElectronico;
    pagaduria.idEstadoFuncionalidad = data.idEstadoFuncionalidad;
    pagaduria.telefonoContacto1 = telefono;
    pagaduria.telefonoContacto2 = telefono2;
    pagaduria.idTipoTelefono1 = data.idTipoTelefono1;
    pagaduria.idTipoTelefono2 = data.idTipoTelefono2;
    pagaduria.digitoVerificacion = data.digitoVerificacion;
    pagaduria.idEntidad = data.idEntidad;
    pagaduria.codigoShivam = data.codigoShivam;
    pagaduria.indicadorHabilitado = true;


    if ( !pagaduria.idPagaduria ) {
      if ( registro.idTercero ) {
        /*const resultado = await this.pagaduriaService.searchByNit( registro.numeroDocumento ).toPromise();
        if ( resultado ) {
          this.navService.setMesage( 0, {
            severity: 'info', summary:
              this.navService.buscarMensaje( 'LBL_INFORMACION' ),
            detail: 'Este tercero ya se encuentra registrado en el sistema'
          } );
          this.guardando = false;
          return;
        }*/

        pagaduria.idTercero = registro.idTercero;
        await this.terServicio.update( registro ).toPromise();
        this.tercero = registro;
        this.enviarTercero(this.tercero.idTercero);
        if ( this.localizacion && ( this.localizacion.idLocalizacion !== null && this.localizacion.idLocalizacion !== '' && this.localizacion.idLocalizacion !== undefined ) ) {
          await this.localizacionService.update( this.localizacion, true ).toPromise();
        } else {
          const addLoca = await this.localizacionService.add( this.localizacion, true ).toPromise();
          this.localizacion.idLocalizacion = addLoca.idLocalizacion;
          terlocalizacion.idlocalizacion = this.localizacion.idLocalizacion;
          terlocalizacion.idTercero = registro.idTercero;
          const addTerloca = await this.terLocalizacionesService.add( terlocalizacion ).toPromise();
          this.terLocalizaciones = addTerloca;
          terlocalizacion.idTerceroLocalizacion = this.terLocalizaciones.idTerceroLocalizacion;
        }
        await this.tertipostercerosService.validateTipTer( this.tercero.idTercero ).toPromise();
        await this.lanzarActualizarDatosPersonas( data, false );
        pagaduria.idTerceroLocalizacion = terlocalizacion.idTerceroLocalizacion;
        const registroCreado = await this.pagaduriaService.add( pagaduria ).toPromise();
        this.pagaduria = await this.pagaduriaService.getById(registroCreado.idPagaduria).toPromise();
        this.f.codigo.setValue(this.pagaduria.codigo);
        this.navService.setMesage( 1 );
        this.formulario.markAsPristine();
        this.abrirAcordeon({index: 1});
        this.guardando = false;
      } else {
        registro.indicadorTerceroNuevo = true;
        const terceroCrear = await this.terServicio.add( registro ).toPromise();
        this.tercero = terceroCrear;
        this.enviarTercero(this.tercero.idTercero);
        pagaduria.idTercero = this.tercero.idTercero;
        const addLoca = await this.localizacionService.add( this.localizacion, true ).toPromise();
        this.localizacion.idLocalizacion = addLoca.idLocalizacion;
        terlocalizacion.idlocalizacion = this.localizacion.idLocalizacion;
        terlocalizacion.idTercero = this.tercero.idTercero;
        this.terLocalizaciones = await this.terLocalizacionesService.add( terlocalizacion ).toPromise();
        terlocalizacion.idTerceroLocalizacion = this.terLocalizaciones.idTerceroLocalizacion;
        await this.tertipostercerosService.validateTipTer( this.tercero.idTercero ).toPromise();
        await this.lanzarActualizarDatosPersonas( data, true );
        pagaduria.idTerceroLocalizacion = terlocalizacion.idTerceroLocalizacion;
        const registroCreado = await this.pagaduriaService.add( pagaduria ).toPromise();
        this.pagaduria = await this.pagaduriaService.getById(registroCreado.idPagaduria).toPromise();
        this.f.codigo.setValue(this.pagaduria.codigo);
        this.navService.setMesage( 1 );
        this.formulario.markAsPristine();
        this.abrirAcordeon({index: 1});
        this.guardando = false;
      }
    } else {
      await this.terServicio.update( registro ).toPromise();
      this.enviarTercero(this.tercero.idTercero);
      await this.localizacionService.update( this.localizacion, true ).toPromise();
      await this.tertipostercerosService.validateTipTer( this.tercero.idTercero ).toPromise();
      await this.lanzarActualizarDatosPersonas( data, false );
      await this.pagaduriaService.update( pagaduria ).toPromise();
      this.pagaduria = pagaduria;
      this.navService.setMesage( 2 );
      this.formulario.markAsPristine();
      this.abrirAcordeon({index: 1});
      this.guardando = false;
    }
  }

  setearTelefonos(data: any) {
    const tipo = this.lisTiposTelefonosAplicables.find( x => x.idLista === data.idTipoTelefono2 );
    const telefono = this.utilidades.quitarMascaraTelefono( data.telefonoContacto2 );
    if (data.idTipoTelefono2 === null){
      this.f.telefonoContacto2.setValue( null );
      this.f.idTipoTelefono2.setValue( null );
    }
    if ( tipo && tipo.codigo === this.tiposTelefonosEnum.CELULAR ) {
      if ( ( telefono.length < 10 || telefono === null ) && data.idTipoTelefono2 ) {
        this.f.telefonoContacto2.setValue( null );
        this.f.idTipoTelefono2.setValue( null );
      } else if ( telefono.length === 10 && !data.idTipoTelefono2 ) {
        this.f.telefonoContacto2.setValue( null );
        this.f.idTipoTelefono2.setValue( null );
      } else if ( !telefono && !data.idTipoTelefono2 ) {
        this.f.telefonoContacto2.setValue( null );
        this.f.idTipoTelefono2.setValue( null );
      }
    } else if ( tipo && tipo.codigo === this.tiposTelefonosEnum.FIJO ) {
      if ( ( telefono.length < 8 || telefono === null ) && data.idTipoTelefono2 ) {
        this.f.telefonoContacto2.setValue( null );
        this.f.idTipoTelefono2.setValue( null );
      } else if ( telefono.length === 8 && !data.idTipoTelefono2 ) {
        this.f.telefonoContacto2.setValue( null );
        this.f.idTipoTelefono2.setValue( null );
      } else if ( !telefono && !data.idTipoTelefono2 ) {
        this.f.telefonoContacto2.setValue( null );
        this.f.idTipoTelefono2.setValue( null );
      }
    }
  }

  cancelar( fDirty: boolean ): void {
    if (fDirty) {
      this.confirmationService.confirm({
        message: ` ¿Está seguro que desea salir sin guardar?`,
        header: 'Confirmación',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate(['apl/pagaduria']);
        }
      });
    } else {
      this.router.navigate(['apl/pagaduria']);
    }
  }


    cancelarAct(fDirty: boolean): void {
        if ( fDirty ) {
          this.confirmationService.confirm( {
            message: ` Se perderán los cambios realizados, ¿desea continuar?`,
            header: 'Confirmación',
            icon: 'fa fa-question-circle',
            accept: () => {
              this.router.navigate( [ 'apl/pagaduria' ] );
            }
          } );
        } else {
          this.router.navigate( [ 'apl/pagaduria' ] );
        }
  }


  regresar( fDirty: boolean ) {
    if ( fDirty ) {
      this.confirmationService.confirm( {
        message: ` Se perderán los cambios realizados, ¿desea continuar?`,
        header: 'Confirmación',
        icon: 'fa fa-question-circle',
        key: 'flujo-venta-datos-basicos',
        accept: () => {
          this.pagaduriasCondicionesService.enviarNotificacionAprobacion( this.pagaduria.idPagaduria ).toPromise();
          this.router.navigate( [ 'apl/pagaduria' ] );
        }
      } );
    } else {
      this.pagaduriasCondicionesService.enviarNotificacionAprobacion( this.pagaduria.idPagaduria ).toPromise();
      this.router.navigate( [ 'apl/pagaduria' ] );
    }
  }

  denegarConfiguracion() {
    this.mosModalDenegacion = true;
  }

  async aprobarConfiguracion() {
    // Lanzar servicio de aprobacion

    this.confirmationService.confirm( {
      message: this.navService.buscarMensaje( 'PAGADURIACONDICIONES.MSG_APROBACION' ),
      header: 'Confirmación',
      icon: 'fa fa-question-circle',
      accept: async() => {
        this.carInformacionInicial = true;
        this.pagaduriaCondicion = {} as PagaduriaCondicion;
        this.pagaduriaCondicion.idPagaduria = this.pagaduria.idPagaduria;
        const aprobacion = await this.pagaduriasCondicionesService.aprobarPagaduriaCondicion( this.pagaduriaCondicion ).toPromise();
        this.carInformacionInicial = false;
        this.location.back();
      },
      reject: () => {
      }
    } );


  }

  cerrarModalDenegacion() {
    this.mosModalDenegacion = false;
  }

  async guardarObservacion() {
    this.campoObservacionSubmitted = true;
    if ( this.campoObservacion ) {
      this.carInformacionInicial = true;
      this.mosModalDenegacion = false;
      this.pagaduriaCondicion = {} as PagaduriaCondicion;
      this.pagaduriaCondicion.idPagaduria = this.pagaduria.idPagaduria;
      this.pagaduriaCondicion.observacion = this.campoObservacion;
      const denegacion = await this.pagaduriasCondicionesService.denegarPagaduriaCondicion( this.pagaduriaCondicion ).toPromise();
      this.carInformacionInicial = false;
      this.location.back();
      // Se manda servicio de denegacion
    }
  }


  validarRolesConfigurados() {
    if (
      !this.contanteRDUCON ||
      !this.contanteRDUAPR ||
      !this.usuarioLogeado ||
      !this.funcionalidad.editar
    ) {
      console.log( 'falta configuracion' );
      return;
    }
    const listRolesDos = this.contanteRDUAPR.valor.split( ',' );

    this.verAprobacionCondicion = this.usuarioLogeado.find( ( x: any ) => x === listRolesDos.find( ( y: any ) => y === x ) ) ? true : false;

  }


  abrirAcordeon(evento: any) {
    this.activeIndex = evento.index;
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'EDITAR';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'CONDICIONES';
        break;
      }
      default: {
        break;
      }
    }
  }

  ngOnDestroy(): void {
    if ( this.pagaduria ) {
      // Enviar notificacion
    }
  }

  enviarTercero(idTercero: string) {
    this.terServicio.enviarTercero(idTercero).toPromise();
  }

  buscarPorFiltros(): Observable<boolean> {
    const a = new BusquedaFiltros();
    a.pagina = 0;
    a.cantidad = 10;
    a.idsEstados = null;
    a.search = this.f.nit.value ? this.f.nit.value : null;

    return this.pagaduriaService.filter(a).pipe(
      map(filter => filter?.data?.length > 0),
      catchError(() => of(false)) // si hay error, devolvemos false
    );
  }
}
